<template>
  <el-table-column
    prop="invoice.invoice_number"
    sortable="custom"
    label="Számla"
    show-overflow-tooltip
    min-width="210"
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row.invoice && scope.row.invoice.invoice_number"
        style="display: inline-block;"
      >
        <receipt-link
          :id="scope.row.invoice_id"
          :label="scope.row.invoice.invoice_number"
          type="invoice"
        />
      </div>
      <el-tag
        v-if="!scope.row.invoice"
        size="small" type="warning"
      >
        Nincs kapcsolódó számla
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
import ReceiptLink from '../../../utils/ReceiptLink';

export default {
  components: { ReceiptLink },
  propName: 'invoice.invoice_number',
};
</script>

